export default "__VITE_ASSET__605efe7c__"